var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.028,
    height: 21.281,
    viewBox: "0 0 20.028 21.281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Person_Icon",
    "data-name": "Person Icon",
    d: "M3.318,21.281a1.112,1.112,0,0,1-1.112-1.113,8.9,8.9,0,0,1,8.9-8.9h2.225a8.9,8.9,0,0,1,8.9,8.9,1.112,1.112,0,0,1-1.112,1.113Zm.141-1.252H20.982a7.659,7.659,0,0,0-7.649-7.511H11.108A7.659,7.659,0,0,0,3.459,20.03ZM7.213,5.007a5.007,5.007,0,1,1,5.008,5.008A5.008,5.008,0,0,1,7.213,5.007Zm1.252,0a3.756,3.756,0,1,0,3.756-3.755A3.761,3.761,0,0,0,8.465,5.007Z",
    transform: "translate(-2.206)",
    fill: "#151515"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.c81acce1500c1d95f4732a905384d835.svg";
export { ForwardRef as ReactComponent };